var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('qrcode-vue',{attrs:{"value":_vm.qr_code_id,"size":160,"level":"H","foreground":"#008841"}}),_vm._v(_vm._s(_vm.kios_name)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }